var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-app":""}},[_c('JobberList',{attrs:{"aJobbers":_vm.aJobbers,"modulo":_vm.modulo,"tipo":'list'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }